module.exports = __webpack_public_path__ + "img/vegetable-sprouts-190x100.2601e098.jpg";